import React from "react";
import { JhText } from "designPackages/textPackage";
import {  UserRoundPlus, UserRoundSearch, } from "lucide-react";

interface StatBoxProps {
  count: number;
  label: string;
  bgColor: string;
  iconColor: string;
  newCount?: number;
  onClick?: () => void;
  className?: string;
}

const StatBox: React.FC<StatBoxProps> = ({ 
  count, 
  label, 
  bgColor, 
  iconColor, 
  newCount, 
  onClick, 
  className 
}) => {
  return (
    <div
      className={` flex items-center gap-2 border border-solid border-border py-1.5 px-2 pr-3 rounded-lg ${className || ""}`}
      onClick={onClick}
    >
      <div
        className={`w-8 h-8 rounded-md flex items-center justify-center `}
        style={{ backgroundColor: bgColor }}
      >
        {label.toLowerCase() === "to review" ? (
          <UserRoundPlus size={16} color={iconColor} />
        ) : (
          <UserRoundSearch size={16} color={iconColor} />
        )}
      </div>
      <div className="flex flex-col justify-center">
        <div className="flex items-center gap-1">
          <JhText variant="emphasis4" color="foreground">
            {count}
          </JhText>
          {newCount && newCount > 0 ? (
            <div className="bg-success-foreground text-white text-[8px] px-1.5 py-0.5 rounded-full font-semibold">
              {newCount}
            </div>
          ) : null}
        </div>
        <JhText variant="caption2" color="foreground">
          {label}
        </JhText>
      </div>
    </div>
  );
};

export default StatBox; 